import React from 'react';
import { ServiceCustomDataProvider } from './context/serviceCustomDataProvider';

import '../assets/css/service.css';
import ServiceModalPlan from '../components/service/serviceModalPlan'

const ServicesPage: React.FC = () => {

    return (
        <ServiceCustomDataProvider>
            <ServiceModalPlan />
        </ServiceCustomDataProvider>
    );
};


export default ServicesPage;